import type { InvoiceStatus } from '../../types';

const STYLES: Record<InvoiceStatus, { label: string; classes: string }> = {
  pending: { label: 'En attente', classes: 'bg-slate-100 text-slate-700 ring-slate-300' },
  extracted: { label: 'Extraite', classes: 'bg-amber-100 text-amber-800 ring-amber-300' },
  validated: { label: 'Validée', classes: 'bg-blue-100 text-blue-800 ring-blue-300' },
  created: { label: 'Créée Zoho', classes: 'bg-emerald-100 text-emerald-800 ring-emerald-300' },
  error: { label: 'Erreur', classes: 'bg-red-100 text-red-800 ring-red-300' },
  rejected: { label: 'Rejetée', classes: 'bg-slate-200 text-slate-600 ring-slate-400 line-through' },
};

export function StatusBadge({ status }: { status: InvoiceStatus }) {
  const s = STYLES[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ${s.classes}`}
    >
      {s.label}
    </span>
  );
}
